import React, { PureComponent, ReactNode } from "react";
import styled from "styled-components";

import styleTheme from "../../theme";
import CircularLoader from "../CircularLoader";

type IButtonProps = Pick<IProps, "disabled" | "fullWidth" | "height" | "theme">;

const StyledButton = styled.button`
  display: flex;
  ${(props: IButtonProps): string => (props.fullWidth ? "width: 100%;" : "")}
  align-items: center;
  justify-content: center;
  min-height: ${(props: IButtonProps): number =>
    props.height ? props.height : 40}px;
  background-color: ${(props: IButtonProps): string =>
    props.disabled
      ? styleTheme.colors.veryLightGrey
      : props.theme === "primary"
      ? styleTheme.colors.black
      : styleTheme.colors.white};
  color: ${(props: IButtonProps): string =>
    props.theme === "primary"
      ? styleTheme.colors.white
      : styleTheme.colors.black};
  font-family: ${styleTheme.fonts.regular};
  font-size: 15px;
  text-transform: uppercase;
  letter-spacing: 2.1px;
  border: ${(props: IButtonProps): string =>
    props.theme === "primary"
      ? "none"
      : `solid 1px ${styleTheme.colors.black}`};
  border-radius: 0;
`;

export interface IProps {
  className?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  height?: number;
  loading?: boolean;
  onClick: () => void; // @TODO: add debounce or so
  theme?: "primary" | "secondary";
  title: string;
  children?: ReactNode | string;
}

type IDefaultProps = Required<
  Pick<
    IProps,
    "className" | "disabled" | "fullWidth" | "height" | "theme" | "loading"
  >
>;

export default class Button extends PureComponent<IProps, {}, IDefaultProps> {
  public static defaultProps: IDefaultProps = {
    className: "",
    disabled: false,
    fullWidth: false,
    height: 40,
    loading: false,
    theme: "primary",
  };

  public render(): ReactNode {
    const {
      className,
      disabled,
      fullWidth,
      height,
      onClick,
      theme,
      title,
      loading,
      children,
    } = this.props;

    return (
      <StyledButton
        height={height}
        fullWidth={fullWidth}
        onClick={onClick}
        className={className}
        theme={theme}
        type="submit"
        disabled={loading || disabled}
      >
        {loading ? <CircularLoader /> : title}
        {children}
      </StyledButton>
    );
  }
}
